import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import ua from './locales/ua.json';

// Initialize i18n
i18n.use(LanguageDetector) // Automatically detect user language
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
        resources: {
            ua: { translation: ua },
            en: { translation: en },
        },
        fallbackLng: 'ua', // Default language
        interpolation: {
            escapeValue: false, // React already escapes content
        },
    });

export default i18n;
